import React from 'react';

const LocationFeatures = () => {
  const features = [
    {
      icon: '🏥',
      title: 'Licensed by the Ministry of Health',
      description: 'Ensuring adherence to the highest standards of care and safety.'
    },
    {
      icon: '👩‍⚕️',
      title: 'Monthly Nurse Practitioner Visits',
      description: 'These visits include medication reviews and chronic illness assessment and monitoring. Clients also have the option to book additional treatments or assessments in the comfort of their home for an additional cost, eliminating the long waits associated with family physician appointments and doctor\'s offices.'
    },
    {
      icon: '💊',
      title: 'Advanced Pharmacy Services',
      description: 'Our pharmacy supplies the latest technology for medication administration and reminders, functioning much like a smart dispensing system that provides both medication and notifications. Additionally, essential supplies like toilet hygiene products and incontinence supplies can be delivered directly to the client\'s room.'
    },
    {
      icon: '🤝',
      title: 'All Ways of Caring Home Care Services',
      description: 'Should a client need a companion for a simple shopping trip, an outing, or a recreational activity, our team can refer them to All Ways of Caring Home Care Services. This partnership also extends to bedside support during hospitalization and assistance with discharge planning, ensuring a smooth transition back home post-hospitalization.'
    }
  ];

  return (
    <section id="location-features" className="location-features">
      <div className="container">
        <div className="section-header">
          <h2>Each of Our Locations Are:</h2>
          <p>Comprehensive support systems designed to provide exceptional care</p>
        </div>

        <div className="features-grid">
          {features.map((feature, index) => (
            <div key={index} className="feature-card">
              <div className="feature-icon">
                <span>{feature.icon}</span>
              </div>
              <div className="feature-content">
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LocationFeatures;